import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPlaceSynonym } from '../../graphql/queries/placeSynonym';
import Header from '../common/Header';

const PlaceSynonym = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="placeSynonyms.show.title"
        linkTo={`/admin/place_synonyms/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getPlaceSynonym(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { placeSynonym } = data;

            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('placeSynonyms.attributes.name')}
                        </div>
                        <div className="common-show__infos--value">{placeSynonym.name}</div>
                        <div className="common-show__infos--field">
                          {t('placeSynonyms.attributes.place')}
                        </div>
                        <div className="common-show__infos--value">{placeSynonym.place.name}</div>
                        <div className="common-show__infos--field">
                          {t('placeSynonyms.attributes.geonameIdentifier')}
                        </div>
                        <div className="common-show__infos--value">
                          {placeSynonym.geonameIdentifier || t('shared.notAvailable')}
                        </div>
                        <div className="common-show__infos--field">
                          {t('placeSynonyms.attributes.locale')}
                        </div>
                        <div className="common-show__infos--value">
                          {placeSynonym.locale || t('shared.notAvailable')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default PlaceSynonym;
